const Commissioned = () => {
  return (
    <div className="w-full items-center py-24 px-4 gap-7 flex-col flex justify-center">
      <div className="max-w-[1106px] gap-10 lg:gap-[97px] items-center justify-between lg:flex-row flex-col flex">
        <div className="w-[160px] lg:w-[280px] h-[160px] lg:h-[280px]">
          <div className="w-[160px] lg:w-[280px]  h-[160px] lg:h-[280px] rounded-full items-center justify-center flex ">
            <img
              src="/assets/images/commission-img.svg"
              className="w-[160px] lg:w-[280px]  h-[160px] lg:h-[280px]"
              alt=""
            />
          </div>
        </div>
        <div className="flex flex-col items-center lg:items-start gap-3">
          <span className="font-semibold font-poppins text-center lg:text-start item text-[36px] text-textBlack">
            Commissioned by the President
          </span>
          <span className="text-[18px] font-poppins text-center lg:text-start font-medium leading-[28px] tracking-[0%]">
            Home and Abroad was officially commissioned by the president of the
            Federal Republic of Nigeria as part of the national initiative to
            provide secure and verified properties for Nigerians at home and in
            the Diaspora.
          </span>
          <div className="flex flex-col md:flex-row gap-2 md:gap-3 w-full md:w-auto pt-4 md:pt-0">
            <button className="hover:cursor-pointer w-full md:w-auto hover:bg-primary/70 transition px-[20px] h-[44px] duration-300 bg-primary rounded-lg text-textWhite flex items-center justify-center shadow-custom gap-2">
              <a
                href="https://guardian.ng/news/nigeria/national/nidcom-sydani-firstbank-launch-home-and-abroad-platform-to-empower-diaspora-nigerians"
                rel="noopener noreferrer"
                target="_blank"
                className="text-textWhite font-poppins font-medium"
              >
                Read the official release
              </a>
              <img
                src="/assets/images/external-fill.svg"
                className="h-[24px]"
                alt=""
              />
            </button>
            <button className="hover:cursor-pointer font-poppins w-full md:w-auto hover:bg-primary/20 h-[44px] px-5 transition duration-300 bg-textWhite rounded-lg text-primary border border-primary flex items-center justify-center shadow-custom gap-2">
              <a
                href="https://www.youtube.com/live/pPZ6RoqNqdM?t=3h32m30s"
                target="_blank"
                rel="noopener noreferrer"
              >
                Watch the event
              </a>
              <img src="/assets/images/play-solid.svg" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commissioned;

export const PoweredBy = () => {
  return (
    <div className="flex flex-wrap px-4 justify-center gap-x-4 items-center">
      <span className="text-textBlack text-nowrap font-medium text-[14px] lg:text-[18px] xl:text-[22px]">
        This is an initiative of
      </span>
      <img
        src="/assets/images/nidcom-log.svg"
        className="w-[70px] lg:w-auto"
        alt=""
      />
      <span className="text-textBlack font-medium  text-[14px] lg:text-[18px] xl:text-[22px] text-nowrap">
        powered by
      </span>
      <img
        src="/assets/images/sydani-gr.svg"
        className="w-[70px] lg:w-auto"
        alt=""
      />
      <span className="text-textBlack font-medium  text-[14px] lg:text-[18px] xl:text-[22px]">
        with
      </span>
      <img
        src="/assets/images/first-bank-new.svg"
        className="max-h-[44px] w-[70px] lg:w-auto"
        alt=""
      />
      <span className="text-textBlack font-medium  text-[14px] lg:text-[18px] xl:text-[22px] text-nowrap">
        as financial partner.
      </span>
    </div>
  );
};
